import { takeEvery } from '../../listenerMiddleware';
import * as commentActions from './actions';
import * as api from '../../api';
import { message } from '@myua/kit';
import { getCurrentAssetId, getEditingComment, getInProgress, getNewComment } from './selectors';
import * as finderActions from '../finder/actions';
import * as lastStateActions from '../lastState/actions';
import { getSharingId } from '../sharing/selectors';

export const commentListeners = () => {
  watchAssetSelected();
  watchAddClicked();
  watchDeleteClicked();
  watchChangeSubmitted();
  watchLoadComments();
};

function watchAssetSelected() {
  takeEvery(
    [finderActions.assetSelected, lastStateActions.applied],
    (action, { getState, dispatch }) => {
      dispatch(commentActions.setNewComment({ assetId: undefined, content: '' }));
      dispatch(commentActions.setEditingComment(undefined));

      const currentAssetId = getCurrentAssetId(getState());
      if (currentAssetId !== undefined) {
        dispatch(commentActions.loadRequested({ assetId: currentAssetId }));
      }
    },
  );
}

function watchLoadComments() {
  takeEvery(commentActions.loadRequested, async ({ payload }, { getState, dispatch }) => {
    const { assetId } = payload;

    const inProgress = getInProgress(getState());
    if (inProgress[assetId]) {
      return;
    }

    const sharingId = getSharingId(getState());

    dispatch(commentActions.setInProgress({ assetId, inProgress: true }));
    const result = await api.loadComments(assetId, sharingId);
    dispatch(commentActions.setInProgress({ assetId, inProgress: false }));

    if (result.success) {
      dispatch(commentActions.commentsLoaded({ assetId, comments: result.data.response }));
    } else {
      const currentAssetId = getCurrentAssetId(getState());
      if (assetId === currentAssetId) {
        // нет смысла отображать ошибку, если юзер уже переключился на другой ассет
        void message.error('Failed to load comments');
      }
    }
  });
}

function watchAddClicked() {
  takeEvery(commentActions.addClicked, async ({ payload }, { getState, dispatch }) => {
    const { assetId, content } = payload;

    dispatch(commentActions.setInProgress({ assetId, inProgress: true }));
    const result = await api.addComment(assetId, content);
    dispatch(commentActions.setInProgress({ assetId, inProgress: false }));

    if (result.success) {
      dispatch(commentActions.loadRequested({ assetId }));

      const newComment = getNewComment(getState());
      if (newComment?.assetId === assetId) {
        dispatch(commentActions.setNewComment({ assetId, content: '' }));
      }
    } else {
      void message.error('Failed to add comment');
    }
  });
}

function watchChangeSubmitted() {
  takeEvery(commentActions.changeSubmitted, async ({ payload }, { getState, dispatch }) => {
    const { assetId, commentId, content } = payload;

    dispatch(commentActions.setInProgress({ assetId, inProgress: true }));
    const result = await api.updateComment(commentId, content);
    dispatch(commentActions.setInProgress({ assetId, inProgress: false }));

    if (result.success) {
      dispatch(commentActions.loadRequested({ assetId }));

      const editingComment = getEditingComment(getState());
      if (editingComment?.id === commentId) {
        dispatch(commentActions.setEditingComment(undefined));
      }
    } else {
      void message.error('Failed to change comment');
    }
  });
}

function watchDeleteClicked() {
  takeEvery(commentActions.deleteClicked, async ({ payload }, { dispatch }) => {
    const { assetId, commentId } = payload;

    dispatch(commentActions.setInProgress({ assetId, inProgress: true }));
    const result = await api.deleteComment(commentId);
    dispatch(commentActions.setInProgress({ assetId, inProgress: false }));

    if (result.success) {
      dispatch(commentActions.loadRequested({ assetId }));
    } else {
      void message.error('Failed to delete comment');
    }
  });
}
